import { Component, EventEmitter, OnDestroy, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Observable, of, Subscription } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { RoutesCons, StringConst } from 'src/app/constants/const';
import { GeneralSearchQueryParams, SearchValue } from 'src/app/model/local/customPaginator.model';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { ObservableService } from 'src/app/services/observable.service';

@Component({
  selector: 'app-general-search',
  templateUrl: './general-search.component.html',
  styleUrls: ['./general-search.component.scss']
})
export class GeneralSearchComponent implements OnInit, OnDestroy {
  @Output() searchEvent = new EventEmitter<void>();
  options: SearchValue[] = [];
  filteredOptions: Observable<string[]> = of([]);
  form: FormGroup;
  subscription = new Subscription();
  hasFocus = false;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private localStorageService: LocalStorageService,
    private observableService: ObservableService) {
    this.form = this.fb.group({
      search: ['', [Validators.minLength(1)]]
    });
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngOnInit(): void {
    this.options = this.localStorageService.getSearch();
    this.subscription.add(
      this.observableService.getGeneralSearch().subscribe(res => {
        this.form.controls.search.setValue(res);
      })
    );
    this.filteredOptions = this.form.controls.search.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value))
    );
  }
  searchFilter(): void {
    const value = this.form.controls.search.value ?? StringConst.empty;
    if (value.trim()) {
      this.searchEvent.emit();
      this.localStorageService.setAddSearch(value);
      const queryParam = new GeneralSearchQueryParams();
      queryParam.itemCode = value;
      this.router.navigate([RoutesCons.generalSearch], { queryParams: queryParam });
      this.options = this.localStorageService.getSearch();
    }
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.options.filter(option => option.value.toLowerCase().indexOf(filterValue) === 0)
      .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
      .map(x => x.value).slice(0, 5);
  }
}
